import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../App';
import PeopleYouMayKnowWidget from '../components/PeopleYouMayKnowWidget';

const Home = () => {
  const { user } = useContext(AuthContext);

  const features = [
    {
      icon: '👥',
      title: 'Connect & Network',
      description: 'Build relationships with fellow merchants, suppliers, and industry experts across Indonesia.',
      color: 'bg-blue-50 text-blue-600'
    },
    {
      icon: '🔍',
      title: 'Discover Opportunities',
      description: 'Find group buying deals, tender opportunities, and exclusive trade offers from your network.',
      color: 'bg-green-50 text-green-600'
    },
    {
      icon: '↗️',
      title: 'Grow Together',
      description: 'Share insights, learn from peers, and grow your business through collaborative commerce.',
      color: 'bg-purple-50 text-purple-600'
    },
    {
      icon: '📋',
      title: 'Trade Efficiently',
      description: 'Post tenders, organize group buys, and streamline your procurement process.',
      color: 'bg-orange-50 text-orange-600'
    }
  ];

  const stats = [
    { value: '15K+', label: 'Active Merchants' },
    { value: '500+', label: 'Trade Groups' },
    { value: '25%', label: 'Cost Savings' }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 to-blue-50">
      {/* Hero Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-20">
        <div className="text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            Welcome to
            <br />
            <span className="text-teal-600">Labamu Hub</span>
          </h1>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Transform your business relationships. Connect with merchants, join buying groups, and discover
            trade opportunities in Indonesia's largest SME ecosystem.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <Link
              to="/feed"
              className="bg-teal-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors"
            >
              Explore Hub
            </Link>
            <Link
              to="/groups"
              className="bg-white text-teal-600 px-8 py-3 rounded-lg font-semibold border-2 border-teal-600 hover:bg-teal-50 transition-colors"
            >
              Join Groups
            </Link>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className={`w-12 h-12 rounded-lg ${feature.color} flex items-center justify-center text-2xl mb-4`}>
                {feature.icon}
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600 text-sm">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            {stats.map((stat, index) => (
              <div key={index} className="border-r border-gray-200 last:border-r-0 md:border-r">
                <div className="text-3xl font-bold text-teal-600 mb-2">{stat.value}</div>
                <div className="text-gray-600">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Welcome Message for User */}
        {user && (
          <div className="mt-12 bg-teal-600 text-white rounded-2xl p-8 text-center">
            <h2 className="text-2xl font-bold mb-4">
              Welcome back, {user.full_name}! 👋
            </h2>
            <p className="text-teal-100 mb-6">
              Ready to connect and grow your business with the community?
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/feed"
                className="bg-white text-teal-600 px-6 py-2 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
              >
                Check Latest Posts
              </Link>
              <Link
                to="/events"
                className="bg-teal-700 text-white px-6 py-2 rounded-lg font-semibold hover:bg-teal-800 transition-colors"
              >
                Upcoming Events
              </Link>
            </div>
          </div>
        )}

        {/* People You May Know Widget - Bottom Position */}
        {user && (
          <div className="max-w-2xl mx-auto mt-12">
            <PeopleYouMayKnowWidget limit={5} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;